export const HTTP_CODES = {
  SUCCESS: 200,
  BAD_REQUEST: 400,
  NOT_FOUND: 404,
  UNPROCESSABLE_ENTITY: 422
};

/**
 * Extracts CSRF token from page header to use it in Ajax requests
 * @returns token
 */
export function getCSRFToken() {
  let csrfToken = document.head.querySelector("[name='csrf-token']");
  if (csrfToken && csrfToken['content']) {
    return csrfToken['content'];
  }
  return '';
}

/**
 * Wrapper for fetch API to make get requests easier
 * URL must be relative
 */
export function doGet(url, params, callback) {
  const urlWithParams = new URL(url, window.location.href);
  if (params !== null) {
    Object.keys(params).forEach(key => urlWithParams.searchParams.append(key, params[key]));
  }
  fetch(urlWithParams, {
    credentials: "same-origin",
    method: "get",
    headers: {
      "Content-Type": "application/json"
    }
  }).then(callback);
}

/**
 * Executes ajax request to given url with given params
 * Takes csrf-token from header and appends it to request params to bypass csrf checks
 * @param url - target url
 * @param payload - object to be passed as request payload (will be encoded as json)
 * @param method - http method to use
 * @param callback - function to be called when response received.
 */
function doAjaxRequest(url, payload, method, callback) {
  fetch(url, {
    body: JSON.stringify(payload),
    credentials: "same-origin",
    method: method,
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json",
      "X-CSRF-Token": getCSRFToken()
    }
  }).then(callback);
}

/**
 * Wrapper for doAjaxRequest to make post requests easier
 */
export function doPost(url, payload, callback) {
  doAjaxRequest(url, payload, "POST", callback);
}

/**
 * Wrapper for doAjaxRequest to make put requests easier
 */
export function doPut(url, payload, callback) {
  doAjaxRequest(url, payload, "PUT", callback);
}

/**
 * Wrapper for doAjaxRequest to make patch requests easier
 */
export function doPatch(url, payload, callback) {
  doAjaxRequest(url, payload, "PATCH", callback);
}

/**
 * Wrapped for doAjaxRequest to make delete requests
 */
export function doDelete(url, payload, callback) {
  doAjaxRequest(url, payload, "DELETE", callback);
}

/**
 * Executes ajax request that POSTs the given FormData
 * Used for uploading files
 * Takes csrf-token from header and appends it to request params to bypass csrf checks
 * @param url - target url
 * @param formData - FormData object to be passed as request payload
 * @param callback - function to be called when response received.
 */
export function doPostFormData(url, formData, callback) {
  fetch(url, {
    body: formData,
    credentials: "same-origin",
    method: "POST",
    headers: {
      "X-CSRF-Token": getCSRFToken()
    }
  }).then(callback);
}